export default __webpack_public_path__ + "d6c91d72174822c06fcdbcada21160f4.png";